module.exports = __webpack_public_path__ + "static/media/animated_ashutosh.cffc8ca3.png";